import { FC, ReactNode, useState } from 'react';
import './index.global.less';
import { Link } from 'react-router-dom';
import { Button, Dropdown, Space, Modal } from 'antd';
import { DownOutlined, ExclamationCircleOutlined, PoweroffOutlined, SwapOutlined, UserOutlined } from '@ant-design/icons';
import ChangePassword from '@/login/ChangePassword';
import { removeCookie, removeStorage } from '@lhb/cache';
import { useMethods } from '@lhb/hook';
import { useVisible } from '@/hooks';
import { loginStore } from '@/store';
import { dispatchNavigate } from '@/common/document-event/dispatch';
import ChangeAccount from '@/login/ChangeAccount';

interface HeaderProps {
  collapsIcon?: ReactNode;
  breadCrumbs?: ReactNode;
  name?: string
  avatar?: string | null;
  crumbs?: any[];
  tenant?: string

}

const { confirm } = Modal;

const { logout } = loginStore;

export const showConfirm = () => {
  confirm({
    title: '退出登录',
    icon: <ExclamationCircleOutlined />,
    content: '是否退出当前登录',
    onOk() {
      logout().then(() => {
        const customToken = window.customToken || 'newPmsToken';
        removeCookie(customToken);
        dispatchNavigate('/');
        removeStorage('pageFilters');
      });

    },
  });
};

const Header: FC<HeaderProps> = ({ collapsIcon, name, tenant, crumbs }) => {
  const { visible, onHidden, onShow } = useVisible(false);
  const [showAccountModal, setShowAccountModal] = useState<boolean>(false);

  const methods = useMethods({
    onModifyPassword() {
      onShow();
    },
    async onLogout() {
      showConfirm();
    },
    onSubmit(success: boolean) {
      success && onHidden();
    },
  });

  const items = [
    {
      key: 'modifyPassword',
      label: <Space size={8}><UserOutlined /><Button onClick={methods.onModifyPassword} type='text'>修改密码</Button></Space>
    },
    {
      key: 'logoout',
      label: <Space size={8}><PoweroffOutlined /><Button onClick={methods.onLogout} type='text'>退出登录</Button></Space>,
    },
  ];

  const prefixCls = 'lhb-header';
  const wrapper = `lhb-header-wrapper`;
  const icon = `lhb-header-icon`;
  const info = `lhb-header-info`;
  const split = `lhb-header-info-split`;
  // 获取到所有路由参数
  return (
    <>
      <header>
        <div className={wrapper}>
          <div className={prefixCls}>
            <div style={{ display: 'flex' }}>
              {/* 折叠板 */}
              <div className={icon}>
                {collapsIcon}
              </div>
              <div style={{ flex: 1 }}>
                <Space size={0} split='/'>
                  {
                    crumbs?.map((item, index) => {
                      const { path, title, disabled } = item;
                      if (disabled) {
                        return title;
                      } else {
                        return (path ? <Link key={path} to={path}>{title}</Link> : <span key={index}>{title}</span>);
                      }
                    })
                  }
                  {/* 选址需求/详情 */}
                </Space>
              </div>
            </div>
            {/** 登录地方 */}
            <div className={info}>
              <Space split={(<span className={split}>|</span>)} size={16}>
                <Space>
                  {tenant}
                  <SwapOutlined onClick={() => setShowAccountModal(true)}/>
                  <span className={split}>|</span>
                  <Dropdown menu={{ items }}>
                    <Space>
                      {name}
                      <DownOutlined style={{ color: '#9EA5B0' }} />
                    </Space>
                  </Dropdown>
                </Space>
              </Space>
              {/** 其他信息 */}
              <div ></div>
              {/** 登录信息 */}
              <div></div>
            </div>
          </div>
        </div>
      </header>
      <ChangePassword visible={visible} onCancelSubmit={onHidden} onSubmit={methods.onSubmit}/>
      <ChangeAccount showAccountModal={showAccountModal} showChangeAccount={setShowAccountModal} />
    </>
  );
};

export default Header;
